export * from 'store/bolt/pixels.js';
import { accessNested } from 'utils/utils';
import Store from 'store/store';

if (USE_LEGACY_TRACKING) {
	Store.on('TICKET_CONVERSION', (data) => {
		if (window.fbq) {
			const store = Store.get();

			const eventDetails = {
				film_name: accessNested(store, 'appData.meta.title.slug'),
				cinema_name: data.theaterName,
				time_slot: data.time,
				date: data.date,
				format: data.format,
				cta: data.provider
			};
			fbq('track', 'ticketClick', eventDetails);
		}
	});
}

// This does not seem to be in Tracking V2 yet so keep it out of the USE_LEGACY_TRACKING if
Store.on('SET_COOKIES', (cats = []) => {
	window.ACCEPTED_COOKIES = cats;
	if (window.dataLayer) {
		window.dataLayer.push({
			event: 'cookies-categories-change',
			categories: cats
		});
	}
});
